import TumengTextEdit from './src/index.vue'

TumengTextEdit.install = function(Vue) {
  Vue.component(TumengTextEdit.name, TumengTextEdit)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengTextEdit)
}

export default TumengTextEdit
